<template>
  <PanelV2
    type="w9"
    mode="simple"
    showGoBack
  >
    <template v-slot:content-solt>
      <img class="icon-tip" src="@/assets/pc/mail-outline@2x.png" />
      <span class="title">We need to make sure it's you</span>
      <span class="sub-title">Please enter the OTP (One-Time PIN) sent to your registered email address.</span>
      <Code @otpCode="complete" />
      <span class="link" @click="sendCode">Did not get any OTP?</span>
      <div class="tip-wrapper">
        <img src="@/assets/pc/Icon - Information@2x.png" />
        <span>OTP is only valid for 5 minutes.</span>
      </div>
      <el-button type="primary" @click="next()" >Submit</el-button>
    </template>
  </PanelV2>
</template>

<script>
  import Code from '../components/code'
  import API from "@/api"
  export default {
    name: 'VerifyOtp',
    pRouter: 'ForgotPassword',
    components: {
      Code
    },
    data() {
      return {
        otpCode: [
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        otpCodeMem: [
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        masked: true,
      }
    },
    watch: {
      masked(val) {
        if (val) {
          this.otpCode = this.otpCode.map(item => {

            return item ? '*' : '';
          })
        } else {
          this.otpCode = this.otpCodeMem.slice();
        }
      }
    },
    methods: {
      toggleMask () {
        this.masked = !this.masked;
      },
      complete(val) {
        this.otpCodeMem = val
      },
      changeCursor(index, event) {
        console.log(index)

        if (['Tab', 'ShiftLeft'].includes(event.code)) {
          return false;
        }

        if (!['ArrowLeft', 'Backspace'].includes(event.code)) {

          if (index < (this.otpCode.length -1) ) {
            this.$refs[`code${ index + 1}`].focus();
          } else {
            // this.$refs[`code0`].focus();
          }
        } else {

          if (index > 0 ) {
            this.$refs[`code${ index - 1}`].focus();
          } else {
            // this.$refs[`code0`].focus();
          }
        }

        this.$nextTick(function() {
          this.maskOtpCode();
        });
      },
      maskOtpCode() {
        const _self = this;
        if (this.masked) {

          this.otpCode = this.otpCode.map(function(item, index) {
            if (!['', '*'].includes(item)) {
              _self.otpCodeMem[index] = item;
              return '*'
            } else {
              return item
            }
          })

        } else {
          this.otpCodeMem = this.otpCode.slice();
        }

      },
      next() {
        const code = this.otpCodeMem.join('')
        if (code.length !== 6) {
          this.showMessageTip('OTP is error')
          return
        }
        const email = sessionStorage.getItem('email')
        API.verifycode({email, code}).then(res => {
          if (res.success) {
            sessionStorage.setItem('code', code)
            this.toNext()
          }
        })
      },
      sendCode() {
        const email = sessionStorage.getItem('email')
        API.sendVerifycode({email}).then(res => {
          if (res.success) {
            console.log(res)
          }
        })
      },
      unmaskOtpCode() {

      }
    },
  }
</script>


<style lang="scss" scoped>
  .panel-v2 {



    .icon-tip {
      width: 64px;
    }

    .title {
      margin: 24px 0 0;
      width: 100%;
      text-align: center;
      font: normal normal normal 20px/24px Nunito-bold;
      letter-spacing: 0px;
      color: #2E2E2E;
    }

    .sub-title {
      margin: 14px 0 0;
      width: 100%;
      text-align: center;
      font: normal normal normal 16px/24px Nunito;
      letter-spacing: 0px;
      color: #2E2E2E;
    }

    .link {
      margin: 32px 0 0;
      font: normal normal normal 16px/24px Nunito-bold;
      letter-spacing: 0px;
      color: #0072D8;
      cursor: pointer;
    }

    .otp-wrapper {
      margin: 32px 0 0;
      display: flex;
      width: 100%;
      height: 60px;
      justify-content: space-between;
      align-items: center;

      input {
        width: 42px;
        height: 100%;
        border: 1px solid #99C1E7;
        border-radius: 8px;
        font-size: 45px;
        text-align: center;
        color: #919191;
      }

      img {
        width: 24px;
        height: 24px;
      }
    }

    .tip-wrapper {
      margin: 24px 0 0 0;
      display: flex;
      width: 269px !important;
      align-items: center;
      word-spacing:normal;

      img {
        width: 19.2px;
        height: 19.2px;
        margin-right: 6px;
      }

      span {
        color: #919191;
        font-size: 14px;
      }

      var {
        font: normal normal normal 14px/24px Nunito-bold;
        letter-spacing: 0px;
        color: #919191;
      }
    }

    .el-button {
      margin: 59px 0 12px 0;
      width: 100%;
    }
  }

</style>
